import React from 'react';
import { Heart } from '@finect/tabular-icons/heart';
import { HeartAction } from './partials';
export var LikeAction = function LikeAction(_ref) {
  var following = _ref.following,
    onFollow = _ref.onFollow;
  return React.createElement("span", null, React.createElement(HeartAction, {
    onClick: onFollow,
    active: following,
    title: "A\xF1adir a favoritos"
  }, React.createElement(Heart, {
    size: "22"
  })));
};